import { IPurchasingGroupMembersDto } from '../types/purchasing-group-members.dto';

export class PurchasingGroupMembers {
    public readonly customerIds: readonly string[];

    constructor(dto: IPurchasingGroupMembersDto) {
        this.customerIds = [...dto.customerIds];
    }
}
